import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCurrentBreakpoint } from '@travel-frontend/core';
import { Image } from '../../../../../../components/UpliftAds/components/Banner/components/Skyscraper/components/Image.js';
export const Skyscraper = ({
  imageMobile,
  imageTablet,
  imageDesktop
}) => {
  const currentBreakpoint = useCurrentBreakpoint();
  const src = {
    xs: imageMobile,
    sm: imageMobile,
    md: imageTablet,
    lg: imageDesktop,
    xl: imageDesktop
  }[currentBreakpoint];
  return _jsx(Image, {
    src: src,
    alt: ""
  });
};